import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;
const LOGO_URL = "https://www.mypanther.fr/web/image/website/1/logo/My%20Panther?unique=501ee63";

export default function RevendeurLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/api/client/login`, { email, password, portal: 'revendeur' }, { withCredentials: true });
      navigate('/revendeur');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erreur de connexion');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-sm border-slate-200 shadow-lg">
        <CardHeader className="text-center pb-2">
          <img src={LOGO_URL} alt="Panther" className="h-12 mx-auto mb-3 object-contain" />
          <CardTitle className="text-lg">Espace Revendeur</CardTitle>
          <p className="text-xs text-slate-500">Connectez-vous à votre espace client</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <Label className="text-sm">Email</Label>
              <Input data-testid="revendeur-email-input" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="votre@email.com" className="mt-1" required />
            </div>
            <div>
              <Label className="text-sm">Mot de passe</Label>
              <Input data-testid="revendeur-password-input" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" className="mt-1" required />
            </div>
            <Button data-testid="revendeur-login-btn" type="submit" className="w-full bg-slate-900 hover:bg-slate-800" disabled={loading}>
              {loading ? 'Connexion...' : 'Se connecter'}
            </Button>
          </form>
          <div className="mt-4 text-center">
            <a href="/login" className="text-xs text-slate-500 hover:text-slate-700">Accès administrateur</a>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
